export type TrainingSectionKind = 'operativa' | 'anagrafica'

export interface TrainingSection {
  slug: string
  name: string
  sidebarLabel: string
  description: string
  kind: TrainingSectionKind
}

export const trainingSections: TrainingSection[] = [
  {
    slug: 'pratiche',
    name: 'Pratiche',
    sidebarLabel: 'Pratiche',
    description: 'Gestione delle richieste di iscrizione ai corsi.',
    kind: 'operativa',
  },
  {
    slug: 'corsi',
    name: 'Corsi',
    sidebarLabel: 'Corsi',
    description: 'Creazione e gestione dei corsi di formazione.',
    kind: 'operativa',
  },
  {
    slug: 'fatturazione',
    name: 'Fatturazione Formazione',
    sidebarLabel: 'Fatturazione',
    description:
      'Fatturazione dei corsi di formazione, da integrarsi nel modulo Fatturazione.',
    kind: 'operativa',
  },
  {
    slug: 'docenti',
    name: 'Anagrafica Docenti',
    sidebarLabel: 'Docenti',
    description: 'Anagrafica dei docenti dei corsi di formazione.',
    kind: 'anagrafica',
  },
  {
    slug: 'prodotti',
    name: 'Database Prodotti + Codici',
    sidebarLabel: 'Prodotti',
    description: 'Database dei prodotti formativi e dei relativi codici.',
    kind: 'anagrafica',
  },
]
